import { DesignLanguage, Link, Text, useIsDesignLanguage } from '@afterpaytouch/core'
import { useTranslation } from '../../utils/convergence'
import React, { FunctionComponent } from 'react'
import styles from './styles.module.css'
import clsx from 'clsx'
import { useIsCountry } from '../../state'
import { Country } from '@afterpay/types'
import { PortalId } from '../../layouts/types'

interface Props {
  visible: boolean
  shouldRender?: boolean
}

export const Footer: FunctionComponent<Props> = ({ visible = false, shouldRender = true }) => {
  const { t } = useTranslation()
  const footerContentClassName = clsx(styles.footerContent, visible && styles.visible)
  const isAUCountry = useIsCountry(Country.AU)
  const isArcadeDesignLanguage = useIsDesignLanguage(DesignLanguage.Arcade)
  if (!shouldRender) {
    return null
  }
  return (
    <div className={styles.footer}>
      <div className={styles.dockedCTA} id={PortalId.DockedFooter} />
      <div className={footerContentClassName} data-testid='footer-content'>
        <Text size={isArcadeDesignLanguage ? 'XXS' : 'XS'} fontFace='CashSansMono'>
          {t('common:footerCopyright', { year: new Date().getFullYear() })}
        </Text>
        <Text size={isArcadeDesignLanguage ? 'XXS' : 'XS'} fontFace='CashSansMono'>
          <Link kind='Underline' testNameSpace='terms' href={t('common:termsOfServiceUrl')} target='_blank'>
            {t('common:footerTerms')}
          </Link>
        </Text>
        <Text size={isArcadeDesignLanguage ? 'XXS' : 'XS'} fontFace='CashSansMono'>
          <Link testNameSpace='privacy-policy' kind='Underline' href={t('common:privacyPolicyUrl')} target='_blank'>
            {t('common:footerPrivacy')}
          </Link>
        </Text>
      </div>
      {isAUCountry && (
        <div className='text-center'>
          <Text size={isArcadeDesignLanguage ? 'XXS' : 'XS'} fontFace='CashSansMono'>
            {t('common:creditLicence', { defaultValue: '' })}
          </Text>
        </div>
      )}
    </div>
  )
}
